import { render, staticRenderFns } from "./SireList.vue?vue&type=template&id=29063edd"
import script from "./SireList.vue?vue&type=script&lang=js"
export * from "./SireList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2296946445/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29063edd')) {
      api.createRecord('29063edd', component.options)
    } else {
      api.reload('29063edd', component.options)
    }
    module.hot.accept("./SireList.vue?vue&type=template&id=29063edd", function () {
      api.rerender('29063edd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/sire/views/SireList.vue"
export default component.exports